import {
  FilterId,
  FilterOptionsType,
  MultiSelectListFilter,
} from 'uplisting-frontend/utils/filters/abstract';

export class AirbnbCancellationPolicyFilter extends MultiSelectListFilter {
  id = FilterId.airbnbCancellationPolicy;
  optionsType = FilterOptionsType.list;
  optionsList = [
    'flexible',
    'moderate',
    'firm',
    'strict',
    'super_strict_30',
    'super_strict_60',
    'non_refundable',
    'limited',
  ];
}
